import { apiCall } from "@/common/api/ApiResult.model";
import { ListResult } from "@/common/models";
import { gql2, formatInput } from "@/gql/lib";
import { ItemFilter, CoordinateInputTier3 } from "@/gql/types";
import axios from "axios";
import { fileParser } from "@/gql/file-parser";

export const getItemsForCluster = gql2<
  {
    clusterUID: string;
    cords: CoordinateInputTier3[];
    cursor: string;
  },
  ListResult<any>
>("tier3-items", (p) => {
  const { clusterUID, cursor, cords } = p;
  const q: ItemFilter = {
    clusterUID,
    coordinates: cords,
    cursor,
  };
  return {
    query: `{ 
    #EXPORT
    items(filter:${formatInput(q)}){
      cursor
      id
      name
      subType
      category
      externalId
      clusterUID
      archive{
        archiveName
        siblings
      }
      extendedProperties{
        topic
      }
      labelHistory{
        userId
      }
      labels{
        infoLabel {
          id
          name
          type
          concreteScore 
          generation
          confidence
        }
        ctxLabels {
          id
          name
          type
          labelType
          labelCategory
          generation
          confidence
        }
        adhocLabels {
          id
          name
        }
        piis {
          id
          name
          labelCategory
        }
      }
      path
      sourceApplication
      sensitivity
      sensitivityLevel
      createdAt
      extendedData
    }
    #EXPORT_END
  }`,
    mapper: fileParser,
  };
});

export const get_cluster_label = apiCall<string, string>(
  "cluster.get-label",
  async (cluster_id) => {
    const res = await axios.get(
      `/label-api/cluster/${cluster_id}?resolve=false`
    );
    return {
      success: true,
      value: res.data.label || "",
    };
  }
);
